import { useAPI } from '@axo/shared/data-access/provider';
import { useMutation, useQueryClient } from 'react-query';
import { debt_register_api } from '@axo/shared/data-access/api';
import { debtRegistryKeys } from '../../cache-keys/debtRegistryKeys.tsx';

export function useUpdateDebtRegistryData() {
  const queryClient = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: debt_register_api.updateDebts(api),
    onSuccess: async (data, params) => {
      queryClient.setQueryData(
        debtRegistryKeys.debts({
          applicationID: params.applicationID,
          SSN: params.SSN,
        }),
        data,
      );
      await queryClient.invalidateQueries(
        debtRegistryKeys.data({
          applicationID: params.applicationID,
        }),
      );
    },
  });
}
